import { render, staticRenderFns } from "./PaxelinClub.vue?vue&type=template&id=cec364d8&"
import script from "./PaxelinClub.vue?vue&type=script&lang=js&"
export * from "./PaxelinClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports